import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { colors, fonts } from '../../styles/theme';

const TooltipHover = styled('div')`
  display: inline;
  font-family: ${fonts.sansSerif};
  position: relative;
`;

function resolvePositions({ left, right, top, bottom }) {
  const positions = { left: 'auto', right: '50%', top: 'auto', bottom: '36px' };

  if (left) positions.left = left;
  if (right) positions.right = right;
  if (top) positions.top = top;
  if (bottom) positions.bottom = bottom;

  return css`
    left: ${positions.left};
    right: ${positions.right};
    top: ${positions.top};
    bottom: ${positions.bottom};
  `;
}

const TooltipMain = styled('div')`
  visibility: ${(props) => (props.hoverOn ? 'visible' : 'hidden')};
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  position: absolute;
  z-index: 250;
  margin-right: -80px;
  min-width: 160px;
  max-width: 320px;
  display: flex;
  justify-content: ${(props) => (props.position === 'start' ? 'flex-start' : 'flex-end')};
  ${resolvePositions}
`;

const TooltipInnerWrapper = styled('div')`
  box-shadow: 0 2px 3px 0 ${colors.grey.secondaryDark};
  border-radius: 4px;
  background: ${colors.white};
  color: ${colors.black};
  display: inline-block;
  padding: 8px 11px;
  border: 1px solid ${colors.blue.secondaryDark};
  float: none;
`;

function Tooltip({ position, content, children, left, right, top, bottom, hide }) {
  const [hoverOn, setHoverOn] = useState(false);
  const toggleHoverOn = () => setHoverOn(true);
  const toggleHoverOff = () => setHoverOn(false);
  return (
    <TooltipHover onMouseEnter={toggleHoverOn} onMouseLeave={toggleHoverOff}>
      {children}
      {!hide && <TooltipMain
        position={position}
        hoverOn={hoverOn}
        left={left}
        right={right}
        top={top}
        bottom={bottom}
      >
        <TooltipInnerWrapper>{content}</TooltipInnerWrapper>
      </TooltipMain>}
    </TooltipHover>
  );
}

Tooltip.defaultProps = {
  left: '',
  right: '',
  top: '',
  bottom: '',
  hide: false
};

Tooltip.propTypes = {
  position: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  content: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  left: PropTypes.string,
  right: PropTypes.string,
  top: PropTypes.string,
  bottom: PropTypes.string,
  hide: PropTypes.bool
};

export { Tooltip, TooltipHover, TooltipMain, TooltipInnerWrapper };
